var map = {
	"./en/btn_1_1.png": "C78Z",
	"./es/btn_1_1.png": "5yYl",
	"./pt/btn_1_1.png": "RuFJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VkUg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_1_1\.png$
// module id = VkUg
// module chunks = 0